export interface EventDialogClasses {
  /** Styles applied to the event dialog root element. */
  eventDialog: string;
  /** Styles applied to the armed-event toolbar root element. */
  eventToolbar: string;
  /** Styles applied to the armed-event toolbar edit button element. */
  eventToolbarEditButton: string;
  /** Styles applied to the armed-event toolbar delete button element. */
  eventToolbarDeleteButton: string;
  /** Styles applied to the anchored (desktop) armed-event toolbar wrapper element. */
  anchoredEventToolbar: string;
  /** Styles applied to the compact (touch) day time grid root element. */
  compactDayTimeGrid: string;
  /** Styles applied to the compact (touch) day time grid content element. */
  compactDayTimeGridContent: string;
  /** Styles applied to the compact (touch) armed-event toolbar dock element. */
  compactEventToolbarDock: string;
  /** Styles applied to the compact editing drawer root element. */
  compactEventDrawer: string;
  /** Styles applied to the compact editing drawer content element. */
  compactEventDrawerContent: string;
  /** Styles applied to the compact editing drawer read-only header element. */
  compactEventDrawerReadonlyHeader: string;
  /** Styles applied to the compact editing drawer read-only title element. */
  compactEventDrawerReadonlyTitle: string;
  /** Styles applied to the event dialog close button element. */
  eventDialogCloseButton: string;
  /** Styles applied to the event dialog header element. */
  eventDialogHeader: string;
  /** Styles applied to the event dialog header actions container element. */
  eventDialogHeaderActions: string;
  /** Styles applied to the event dialog readonly content element. */
  eventDialogReadonlyContent: string;
  /** Styles applied to the event dialog actions element. */
  eventDialogActions: string;
  /** Styles applied to the event dialog date time container element. */
  eventDialogDateTimeContainer: string;
  /** Styles applied to the event dialog title element. */
  eventDialogTitle: string;
  /** Styles applied to the event dialog resource container element. */
  eventDialogResourceContainer: string;
  /** Styles applied to the event dialog resource legend container element. */
  eventDialogResourceLegendContainer: string;
  /** Styles applied to the event dialog resource legend color element. */
  eventDialogResourceLegendColor: string;
  /** Styles applied to the event dialog resource title element. */
  eventDialogResourceTitle: string;
  /** Styles applied to the event dialog paper element. */
  eventDialogPaper: string;
  /** Styles applied to the event dialog form element. */
  eventDialogForm: string;
  /** Styles applied to the event dialog form actions element. */
  eventDialogFormActions: string;
  /** Styles applied to the event dialog content element. */
  eventDialogContent: string;
  /** Styles applied to the event dialog tab panel element. */
  eventDialogTabPanel: string;
  /** Styles applied to the event dialog tab content element. */
  eventDialogTabContent: string;
  /** Styles applied to the event dialog date time fields container element. */
  eventDialogDateTimeFieldsContainer: string;
  /** Styles applied to the event dialog date time fields row element. */
  eventDialogDateTimeFieldsRow: string;
  /** Styles applied to the event dialog recurrence label container element in the readonly content. */
  eventDialogRecurrenceLabelContainer: string;
  /** Styles applied to the event dialog recurrence selector container element. */
  eventDialogRecurrenceSelectorContainer: string;
  /** Styles applied to the event dialog resource menu item element. */
  eventDialogResourceMenuItem: string;
  /** Styles applied to the event dialog resource menu list subheader element. */
  eventDialogResourceMenuListSubheader: string;
  /** Styles applied to the event dialog resource menu color dot element. */
  eventDialogResourceMenuColorDot: string;
  /** Styles applied to the event dialog resource menu color toggle group element. */
  eventDialogResourceMenuColorToggleGroup: string;
  /** Styles applied to the event dialog resource menu color toggle element. */
  eventDialogResourceMenuColorToggle: string;
  /** Styles applied to the event dialog inline row element. */
  eventDialogInlineRow: string;
  /** Styles applied to the event dialog section header title element. */
  eventDialogSectionHeaderTitle: string;
  /** Styles applied to the event dialog section fieldset element. */
  eventDialogSectionFieldset: string;
  /** Styles applied to the event dialog radio button label element. */
  eventDialogRadioButtonLabel: string;
  /** Styles applied to the event dialog repeat section label element. */
  eventDialogRepeatSectionLabel: string;
  /** Styles applied to the event dialog ends radio group element. */
  eventDialogEndsRadioGroup: string;
  /** Styles applied to the event dialog repeat section fieldset element. */
  eventDialogRepeatSectionFieldset: string;
  /** Styles applied to the event dialog repeat section content element. */
  eventDialogRepeatSectionContent: string;
  /** Styles applied to the event dialog recurrence selector toggle group element. */
  eventDialogRecurrenceSelectorToggleGroup: string;
  /** Styles applied to the event dialog week day selector form group element. */
  eventDialogWeekDaySelectorCheckbox: string;
  /** Styles applied to the event dialog frequency select element. */
  eventDialogFrequencySelect: string;
  /** Styles applied to the event dialog small number field element. */
  eventDialogSmallNumberField: string;
  /** Styles applied to the event dialog tabs container element. */
  eventDialogTabsContainer: string;
  /** Styles applied to the event dialog tab elements. */
  eventDialogTab: string;
  /** Styles applied to the event dialog form divider element. */
  eventDialogFormDivider: string;
  /** Styles applied to the event dialog delete button element. */
  eventDialogDeleteButton: string;
  /** Styles applied to the event dialog save button element. */
  eventDialogSaveButton: string;
  /** Styles applied to the event dialog close action button element. */
  eventDialogCloseAction: string;
  /** Styles applied to the event dialog date time icon element. */
  eventDialogDateTimeIcon: string;
  /** Styles applied to the event dialog date time label element. */
  eventDialogDateTimeLabel: string;
  /** Styles applied to the event dialog recurrence icon element. */
  eventDialogRecurrenceIcon: string;
  /** Styles applied to the event dialog recurrence label element. */
  eventDialogRecurrenceLabel: string;
  /** Styles applied to the recurrence timezone note and label suffix elements. */
  eventDialogRecurrenceTimezoneLabel: string;
  /** Styles applied to the event dialog description label element. */
  eventDialogDescriptionLabel: string;
}

export type EventDialogClassKey = keyof EventDialogClasses;

export const eventDialogClassKeys: EventDialogClassKey[] = [
  'eventDialog',
  'eventToolbar',
  'eventToolbarEditButton',
  'eventToolbarDeleteButton',
  'anchoredEventToolbar',
  'compactDayTimeGrid',
  'compactDayTimeGridContent',
  'compactEventToolbarDock',
  'compactEventDrawer',
  'compactEventDrawerContent',
  'compactEventDrawerReadonlyHeader',
  'compactEventDrawerReadonlyTitle',
  'eventDialogCloseButton',
  'eventDialogHeader',
  'eventDialogHeaderActions',
  'eventDialogReadonlyContent',
  'eventDialogActions',
  'eventDialogDateTimeContainer',
  'eventDialogTitle',
  'eventDialogResourceContainer',
  'eventDialogResourceLegendContainer',
  'eventDialogResourceLegendColor',
  'eventDialogResourceTitle',
  'eventDialogPaper',
  'eventDialogForm',
  'eventDialogFormActions',
  'eventDialogContent',
  'eventDialogTabPanel',
  'eventDialogTabContent',
  'eventDialogDateTimeFieldsContainer',
  'eventDialogDateTimeFieldsRow',
  'eventDialogResourceMenuItem',
  'eventDialogResourceMenuListSubheader',
  'eventDialogResourceMenuColorDot',
  'eventDialogResourceMenuColorToggleGroup',
  'eventDialogResourceMenuColorToggle',
  'eventDialogRecurrenceLabelContainer',
  'eventDialogRecurrenceSelectorContainer',
  'eventDialogInlineRow',
  'eventDialogSectionHeaderTitle',
  'eventDialogSectionFieldset',
  'eventDialogRadioButtonLabel',
  'eventDialogRepeatSectionLabel',
  'eventDialogEndsRadioGroup',
  'eventDialogRepeatSectionFieldset',
  'eventDialogRepeatSectionContent',
  'eventDialogRecurrenceSelectorToggleGroup',
  'eventDialogWeekDaySelectorCheckbox',
  'eventDialogFrequencySelect',
  'eventDialogSmallNumberField',
  'eventDialogTabsContainer',
  'eventDialogTab',
  'eventDialogFormDivider',
  'eventDialogDeleteButton',
  'eventDialogSaveButton',
  'eventDialogCloseAction',
  'eventDialogDateTimeIcon',
  'eventDialogDateTimeLabel',
  'eventDialogRecurrenceIcon',
  'eventDialogRecurrenceLabel',
  'eventDialogRecurrenceTimezoneLabel',
  'eventDialogDescriptionLabel',
];

// Create a slots object for reuse in useUtilityClasses (avoids duplication in EventCalendar.tsx and EventTimelinePremium.tsx)
export const eventDialogSlots: Record<EventDialogClassKey, [EventDialogClassKey]> = {
  eventDialog: ['eventDialog'],
  eventToolbar: ['eventToolbar'],
  eventToolbarEditButton: ['eventToolbarEditButton'],
  eventToolbarDeleteButton: ['eventToolbarDeleteButton'],
  anchoredEventToolbar: ['anchoredEventToolbar'],
  compactDayTimeGrid: ['compactDayTimeGrid'],
  compactDayTimeGridContent: ['compactDayTimeGridContent'],
  compactEventToolbarDock: ['compactEventToolbarDock'],
  compactEventDrawer: ['compactEventDrawer'],
  compactEventDrawerContent: ['compactEventDrawerContent'],
  compactEventDrawerReadonlyHeader: ['compactEventDrawerReadonlyHeader'],
  compactEventDrawerReadonlyTitle: ['compactEventDrawerReadonlyTitle'],
  eventDialogCloseButton: ['eventDialogCloseButton'],
  eventDialogHeader: ['eventDialogHeader'],
  eventDialogHeaderActions: ['eventDialogHeaderActions'],
  eventDialogReadonlyContent: ['eventDialogReadonlyContent'],
  eventDialogActions: ['eventDialogActions'],
  eventDialogDateTimeContainer: ['eventDialogDateTimeContainer'],
  eventDialogTitle: ['eventDialogTitle'],
  eventDialogResourceContainer: ['eventDialogResourceContainer'],
  eventDialogResourceLegendContainer: ['eventDialogResourceLegendContainer'],
  eventDialogResourceLegendColor: ['eventDialogResourceLegendColor'],
  eventDialogResourceTitle: ['eventDialogResourceTitle'],
  eventDialogPaper: ['eventDialogPaper'],
  eventDialogForm: ['eventDialogForm'],
  eventDialogFormActions: ['eventDialogFormActions'],
  eventDialogContent: ['eventDialogContent'],
  eventDialogTabPanel: ['eventDialogTabPanel'],
  eventDialogTabContent: ['eventDialogTabContent'],
  eventDialogDateTimeFieldsContainer: ['eventDialogDateTimeFieldsContainer'],
  eventDialogDateTimeFieldsRow: ['eventDialogDateTimeFieldsRow'],
  eventDialogResourceMenuItem: ['eventDialogResourceMenuItem'],
  eventDialogResourceMenuListSubheader: ['eventDialogResourceMenuListSubheader'],
  eventDialogResourceMenuColorDot: ['eventDialogResourceMenuColorDot'],
  eventDialogResourceMenuColorToggleGroup: ['eventDialogResourceMenuColorToggleGroup'],
  eventDialogResourceMenuColorToggle: ['eventDialogResourceMenuColorToggle'],
  eventDialogRecurrenceLabelContainer: ['eventDialogRecurrenceLabelContainer'],
  eventDialogRecurrenceSelectorContainer: ['eventDialogRecurrenceSelectorContainer'],
  eventDialogInlineRow: ['eventDialogInlineRow'],
  eventDialogSectionHeaderTitle: ['eventDialogSectionHeaderTitle'],
  eventDialogSectionFieldset: ['eventDialogSectionFieldset'],
  eventDialogRadioButtonLabel: ['eventDialogRadioButtonLabel'],
  eventDialogRepeatSectionLabel: ['eventDialogRepeatSectionLabel'],
  eventDialogEndsRadioGroup: ['eventDialogEndsRadioGroup'],
  eventDialogRepeatSectionFieldset: ['eventDialogRepeatSectionFieldset'],
  eventDialogRepeatSectionContent: ['eventDialogRepeatSectionContent'],
  eventDialogRecurrenceSelectorToggleGroup: ['eventDialogRecurrenceSelectorToggleGroup'],
  eventDialogWeekDaySelectorCheckbox: ['eventDialogWeekDaySelectorCheckbox'],
  eventDialogFrequencySelect: ['eventDialogFrequencySelect'],
  eventDialogSmallNumberField: ['eventDialogSmallNumberField'],
  eventDialogTabsContainer: ['eventDialogTabsContainer'],
  eventDialogTab: ['eventDialogTab'],
  eventDialogFormDivider: ['eventDialogFormDivider'],
  eventDialogDeleteButton: ['eventDialogDeleteButton'],
  eventDialogSaveButton: ['eventDialogSaveButton'],
  eventDialogCloseAction: ['eventDialogCloseAction'],
  eventDialogDateTimeIcon: ['eventDialogDateTimeIcon'],
  eventDialogDateTimeLabel: ['eventDialogDateTimeLabel'],
  eventDialogRecurrenceIcon: ['eventDialogRecurrenceIcon'],
  eventDialogRecurrenceLabel: ['eventDialogRecurrenceLabel'],
  eventDialogRecurrenceTimezoneLabel: ['eventDialogRecurrenceTimezoneLabel'],
  eventDialogDescriptionLabel: ['eventDialogDescriptionLabel'],
};
